var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgArrowUpGreen = function SvgArrowUpGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 27",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.06.632a1.5 1.5 0 00-2.12 0l-9.547 9.546A1.5 1.5 0 103.515 12.3L12 3.815l8.485 8.486a1.5 1.5 0 102.122-2.122L13.06.632zm.44 26.06v-25h-3v25h3z",
    fill: "#33BB40"
  })));
};

export default SvgArrowUpGreen;